import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  notificationsChanges: true,
};

export const notificationsSlice = createSlice({
  name: "notificationsState",
  initialState,
  reducers: {
    updateNotificationsChanges: (state) => {
      state.notificationsChanges = !state.notificationsChanges;
    },

    replaceNotifications: (state, action) => {
      const incoming = action.payload?.notifications;

      if (!Array.isArray(incoming)) {
        state.notifications = [];
        return;
      }

      const byId = new Map();
      const withoutId = [];

      for (const notification of incoming) {
        if (notification?.id != null) {
          byId.set(notification.id, notification);
        } else {
          withoutId.push(notification);
        }
      }

      state.notifications = [...byId.values(), ...withoutId].sort(
        (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime(),
      );
    },

    updateNotifications: (state, action) => {
      const incoming = action.payload?.notifications;

      if (Array.isArray(incoming)) {
        const byId = new Map();
        const withoutId = [];

        for (const notification of [...(state.notifications || []), ...incoming]) {
          if (notification?.id != null) {
            byId.set(notification.id, notification);
          } else {
            withoutId.push(notification);
          }
        }

        state.notifications = [...byId.values(), ...withoutId].sort(
          (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime(),
        );

        return;
      }

      Object.assign(state, action.payload);
    },

    pushNotification: (state, action) => {
      const payload = action.payload;
      const hasId = payload?.id != null;
      const existing = state.notifications || [];

      if (hasId && existing.some((notification) => notification.id === payload.id)) {
        return;
      }

      const withRead =
        payload?.isRead === undefined
          ? {
              ...payload,
              isRead: false,
            }
          : payload;

      state.notifications = [withRead, ...existing];
    },
  },
  devTools: "production",
});

export const { updateNotificationsChanges, replaceNotifications, updateNotifications, pushNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
